import $axios from '@/axios-instance.js'

export const contactService = {
  getAll,
  getById,
  getListData,
  getContactsByProjectId,
  create,
  update,
  createProjectContact,
  delete: _delete,
  downloadPersonAsCsv
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/contacts/get-all`).then(response => {
    return response.data
  })
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/contacts`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/contacts/${id}`).then(response => {
    return response.data
  })
}

function getContactsByProjectId (id) {
  return $axios.get(`${process.env.ROOT_API}/contacts/project/${id}`).then(response => {
    return response.data
  })
}

function create (contact) {
  return $axios.post(`${process.env.ROOT_API}/contacts`, contact).then(response => {
    return response.data
  })
}

function createProjectContact (contact) {
  return $axios.post(`${process.env.ROOT_API}/contacts/projectcontact`, contact).then(response => {
    return response.data
  })
}

function update (contact) {
  return $axios.put(`${process.env.ROOT_API}/contacts/${contact.contactId}`, contact).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/contacts/${id}`).then(response => {
    return response.data
  })
}

function downloadPersonAsCsv (id) {
  var config = {
    headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    responseType: 'blob'
  }
  return $axios.post(`${process.env.ROOT_API}/contacts/export/${id}`, { id: id }, config).then(response => {
    return response
  }).catch(error => {
    console.error(error.response)
  })
}



// WEBPACK FOOTER //
// ./src/services/contact.service.js